// extracted by mini-css-extract-plugin
export default {"container":"alt-button_container__h+oLD"};